import { render } from "./PersonalPhotography2.vue?vue&type=template&id=4186c630&scoped=true"
import script from "./PersonalPhotography2.vue?vue&type=script&lang=js"
export * from "./PersonalPhotography2.vue?vue&type=script&lang=js"

import "./PersonalPhotography2.vue?vue&type=style&index=0&id=4186c630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4186c630"]])

export default __exports__